import React                      from 'react'
import { Observer }               from 'mobx-react'

import { kde_api_user_t }         from '../02_api'
import { FACTORY
       , MApp }                   from '../09_model_app'
import { UsersTable }             from '../10_ui'

import { MWorkGroups }            from './01_screen_workgroups_model'


export const WorkgroupUsersTable: React.FC = () =>
<Observer render={ ( ) =>
{
  const model = MWorkGroups.instance( )
      , on_edit = async ( user: kde_api_user_t, new_values: Partial<kde_api_user_t> ) =>
        {
          await model.users.on_edit( user, new_values ) ;

          // Editing a user may change the workgroup => need to refresh when we display the workgroup it was moved to
          FACTORY.WORKGROUP_USERS.reset( ) ;
        }
      , src = model.users.data_for_page( 0 ) ;

  return <UsersTable
          loading={ src.loading }
          users={ src.data.slice( 0 ) }
          onDelete={ model.users.on_delete }
          onEdit={ on_edit }
          canEdit={ MApp( ).can_edit_workgroups }
        />
} }/>